import { createSelector } from 'reselect';

import { IBenefit } from '../../types/developer/benefits';
import { IApplicationState } from '../../types/redux';

const emptyBenefits = Array.of<IBenefit>();

const getFskPromoTiles = (state: IApplicationState) => state.fsk?.promoTiles;
const getDeveloperState = (state: IApplicationState) => state.developer;

export const getBenefits = createSelector([getFskPromoTiles, getDeveloperState], (fskPromoTiles, developer) => {
  if (fskPromoTiles) {
    return fskPromoTiles.map((promoTile, index) => ({
      description: promoTile.description,
      id: index,
      image: promoTile.image,
      title: promoTile.title,
      url: '#',
    }));
  }

  if (!developer) {
    return emptyBenefits;
  }

  return developer.benefits;
});
